import { render, staticRenderFns } from "./region-list-page.vue?vue&type=template&id=92f160c0&scoped=true&"
import script from "./region-list-page.vue?vue&type=script&lang=js&"
export * from "./region-list-page.vue?vue&type=script&lang=js&"
import style0 from "./region-list-page.vue?vue&type=style&index=0&id=92f160c0&lang=scss&scoped=true&"
import style1 from "./region-list-page.vue?vue&type=style&index=1&id=92f160c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f160c0",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QCard})
